import {ButtonHTMLAttributes} from 'react'
import classNames from 'classnames'

interface Props extends ButtonHTMLAttributes<any> {
	label: string
}

export default function Button(props: Props) {
	const {label, ...rest} = props
	return (
		<button
			className={classNames(`
				bg-pulse-blue text-white shadow-md uppercase
				py-1 px-3 m-2
				rounded-lg
				hover:shadow-lg
			`, {
				'bg-pulse-label-gray': props.disabled === true
			})}
			{...rest}
		>{label}</button>
	)
}
